import * as CryptoJS from 'crypto-js';
var Encryptor = (function () {
    function Encryptor(persistor, options) {
        if (!options.secretKey) {
            throw new Error('In order to encrypt your Apollo Cache, you need to pass in a secretKey. ');
        }
        this._onError = options.onError;
        this.secretKey = options.secretKey;
        this.persistor = persistor;
    }
    Encryptor.prototype.encrypt = function (data) {
        return CryptoJS.AES.encrypt(data, this.secretKey).toString();
    };
    Encryptor.prototype.decrypt = function (data) {
        var bytes = CryptoJS.AES.decrypt(data, this.secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    };
    Encryptor.prototype.onError = function (error) {
        this._onError(error, this.persistor);
    };
    return Encryptor;
}());
export default Encryptor;
//# sourceMappingURL=Encryptor.js.map